// Generated by scripts/login_captcha/emit.mjs; edit the TypeScript source.
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './LoginCaptcha.component.css';
const messages = {
    loading: '보안 확인 중…',
    verified: '보안 확인 완료',
    submitting: '로그인 중…',
    expired: '보안 확인이 만료되었습니다.',
    error: '보안 확인에 실패했습니다. 다시 시도해 주세요.',
};
export function LoginCaptcha({ captcha, purpose = 'login' }) {
    if (!captcha.required)
        return null;
    const retryable = captcha.state === 'error' || captcha.state === 'expired';
    return _jsxs("section", { className: "login-captcha", "aria-label": purpose === 'signup' ? '가입 보안 확인' : '로그인 보안 확인', children: [_jsx("span", { "aria-hidden": "true", children: captcha.state === 'verified' ? '✓' : '·' }), _jsx("p", { className: "login-captcha__status", "aria-live": "polite", children: purpose === 'signup' && captcha.state === 'submitting' ? '가입 중…' : messages[captcha.state] }), retryable && _jsx("button", { className: "login-captcha__retry", type: "button", onClick: captcha.retry, children: "\uB2E4\uC2DC \uD655\uC778" })] });
}
